import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { localStorage } from '#app/services/storage.js';
import { type Page } from './types.js';
import { useCallback, useState } from 'react';

const BASE_KEY = 'CONTRA_LOCAL_REQUEST_RECOMMENDATIONS_CTA_OPT_OUT';

type UseRequestRecommendationReturn = {
  handleCTAClick: () => void;
  handleCTADismiss: () => void;
  hasDismissedCTA: boolean;
};

/**
 * @package
 */
export const useRequestRecommendation = (
  page: Page,
): UseRequestRecommendationReturn => {
  const { track } = useAnalytics();

  const storageKey = `${BASE_KEY}_${page.toUpperCase()}` as const;

  const [storageKeyValue, setStorageKeyValue] = useState(
    localStorage.getItem(storageKey),
  );

  const hasDismissedCTA = storageKeyValue === 'true';

  const handleCTADismiss = useCallback(() => {
    setStorageKeyValue('true');
    localStorage.setItem(storageKey, 'true');

    track('button', {
      action: 'tapped',
      button_name: 'growth_recommendations_request_cta_dismiss',
      section: page,
    });
  }, [page, storageKey, track]);

  const handleCTAClick = useCallback(() => {
    track('button', {
      action: 'tapped',
      button_name: 'growth_recommendations_request_cta_primary',
      section: page,
    });
  }, [page, track]);

  return {
    handleCTAClick,
    handleCTADismiss,
    hasDismissedCTA,
  };
};
